import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getInvoicingDiagnostics = ({ payload }) =>
  call(websocketFetch, 'get_invoicing_diagnostics', {
    date: payload,
  });
